import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { calculatorService } from '../../services/calculatorService';

export const useGetCalculatorConstants = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.calculator.constants],
    queryFn: () =>
      calculatorService.constants().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
